import { query } from '../../../1_shared/api/apiInstance';

import { ClientProfileSessionOutput } from './interfaces/ClientProfileSessionOutput';

export const getSessions = query<null, ClientProfileSessionOutput>();
